import type { AuthUser } from "@/lib/auth";

/** 展示名：display_name → 邮箱 @ 前 → 手机尾 4 位 → 用户 #id */
export function userDisplayLabel(
  user: Pick<AuthUser, "display_name" | "email" | "phone" | "id">,
): string {
  const name = user.display_name?.trim();
  if (name) return name;

  const local = user.email?.split("@", 2)[0]?.trim();
  if (local) return local;

  const digits = user.phone?.replace(/\D/g, "") ?? "";
  if (digits.length >= 4) return digits.slice(-4);

  return `用户 #${user.id}`;
}

/** 头像首字母：优先 API avatar_initial，否则邮箱/展示名首字 */
export function userAvatarInitial(
  user: Pick<AuthUser, "email" | "display_name" | "avatar_initial">,
): string {
  const initial = user.avatar_initial?.trim();
  if (initial) return initial;

  const source = user.email?.trim() || user.display_name?.trim() || "";
  const letter = source.charAt(0).toUpperCase();
  return letter || "?";
}
